export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/fin/tp',
		name: 'NbuFinTp',
		title: {
			single: 'NbuFinTp',
			plural: 'NbuFinTps'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": 202,
				"code": "А",
				"name": "Агент",
				"caption": "Агент",
				"isBlocked": false
			},
			{
				"id": 1,
				"code": "17",
				"name": "Адміністратор недержавних пенсійних фондів",
				"caption": "Адміністратор недержавних пенсійних фондів",
				"isBlocked": true
			},
			{
				"id": 101,
				"code": "",
				"name": "Актуарії",
				"caption": "Актуарії",
				"isBlocked": false
			},
			{
				"id": 102,
				"code": "",
				"name": "Аудитори",
				"caption": "Аудитори",
				"isBlocked": false
			},
			{
				"id": 201,
				"code": "Б",
				"name": "Брокер",
				"caption": "Брокер",
				"isBlocked": false
			},
			{
				"id": 106,
				"code": "",
				"name": "Бюро кредитних історій",
				"caption": "Бюро кредитних історій",
				"isBlocked": false
			},
			{
				"id": 9,
				"code": "19",
				"name": "Довірче товариство",
				"caption": "Довірче товариство",
				"isBlocked": false
			},
			{
				"id": 8,
				"code": "",
				"name": "Інша кредитна установа",
				"caption": "Інша кредитна установа",
				"isBlocked": true
			},
			{
				"id": 7,
				"code": "20",
				"name": "Інша фінансова компанія",
				"caption": "Інша фінансова компанія",
				"isBlocked": true
			},
			{
				"id": 4,
				"code": "14",
				"name": "Кредитна спілка",
				"caption": "Кредитна спілка",
				"isBlocked": false
			},
			{
				"id": 20,
				"code": "25",
				"name": "Лізингодавець ",
				"caption": "Лізингодавець ",
				"isBlocked": false
			},
			{
				"id": 105,
				"code": "",
				"name": "Лізингодавці",
				"caption": "Лізингодавці",
				"isBlocked": true
			},
			{
				"id": 6,
				"code": "15",
				"name": "Ломбард",
				"caption": "Ломбард",
				"isBlocked": false
			},
			{
				"id": 104,
				"code": "",
				"name": "Навчальні заклади",
				"caption": "Навчальні заклади",
				"isBlocked": false
			},
			{
				"id": 2,
				"code": "12",
				"name": "Недержавний пенсійний фонд",
				"caption": "Недержавний пенсійний фонд",
				"isBlocked": true
			},
			{
				"id": 10,
				"code": "173",
				"name": "Одноосібний засновник корпоративного НПФ",
				"caption": "Одноосібний засновник корпоративного НПФ",
				"isBlocked": true
			},
			{
				"id": 30,
				"code": "30",
				"name": "Оператор поштового зв'язку",
				"caption": "Оператор поштового зв'язку",
				"isBlocked": false
			},
			{
				"id": 103,
				"code": "",
				"name": "Саморегулівні організації ФУ",
				"caption": "Саморегулівні організації ФУ",
				"isBlocked": false
			},
			{
				"id": 3,
				"code": "11",
				"name": "Страхова компанія",
				"caption": "Страхова компанія",
				"isBlocked": false
			},
			{
				"id": 40,
				"code": "40",
				"name": "Страховик із спеціальним статусом",
				"caption": "Страховик із спеціальним статусом",
				"isBlocked": false
			},
			{
				"id": 107,
				"code": "",
				"name": "Страхові та перестрахові брокери (резиденти та нерезиденти)",
				"caption": "Страхові та перестрахові брокери (резиденти та нерезиденти)",
				"isBlocked": false
			},
			{
				"id": 108,
				"code": "",
				"name": "Тимчасові адміністратори ",
				"caption": "Тимчасові адміністратори ",
				"isBlocked": false
			},
			{
				"id": 5,
				"code": "13",
				"name": "Фінансова компанія",
				"caption": "Фінансова компанія",
				"isBlocked": false
			}
		],
	},
}
